import { createSelector } from 'reselect'
import { createCommunicationSelectors } from 'src/helpers/redux'
import { IState, PREFIX, TGlobalStateWithService } from './state'
import { actions } from './actions'

export const selectData = (state: TGlobalStateWithService): IState['data'] =>
  state[PREFIX].data

export const selectCommunication = (
  state: TGlobalStateWithService
): IState['communication'] => state[PREFIX].communication

export const communications = createCommunicationSelectors<
  TGlobalStateWithService,
  IState['communication'],
  typeof actions
>(selectCommunication, actions)

export const selectors = {
  threads: createSelector(selectData, (state) => state.threads),
  messages: createSelector(
    selectData,
    (state) => state.threads[0]?.messages || []
  ),
  isStreaming: createSelector(selectData, (state) => {
    const firstThread = state.threads[0]
    if (!firstThread?.messages) return false

    return firstThread.messages.some((msg) => msg.streamingText !== undefined)
  }),

  window: createSelector(selectData, (state) => state.window),
  context: createSelector(selectData, (state) => state.context),
  windowOpenRightSideBar: createSelector(
    selectData,
    (state) => state.window.open && state.window.rightSideBar
  ),

  windowOpen: createSelector(selectData, (state) => state.window.open),
  data: createSelector(selectData, (state) => state),
}
